import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

import { paths } from 'src/routes/paths';
import { useRouter, usePathname } from 'src/routes/hooks';

import { Label } from 'src/components/label';
import { usePopover, CustomPopover } from 'src/components/custom-popover';

import { useAuthContext, useMockedUser } from 'src/auth/hooks';

import { Button } from '@mui/material';
import { AccountButton } from './account-button';
import { SignOutButton } from './sign-out-button';

// ----------------------------------------------------------------------

export function AccountPopover({ data = [], sx, ...other }) {
  const router = useRouter();

  const popover = usePopover();

  const pathname = usePathname();

  const { user } = useAuthContext();

  // isEmployeeOnly
  const isEmployeeOnly = user?.role?.length === 1 && user?.role[0]?.name === 'employee';

  const handleClickItem = (path) => {
    popover.onClose();
    router.push(path);
  };

  return (
    <>
      {(user?.name || user?._id) && (
        <AccountButton
          open={popover.open}
          onClick={popover.onOpen}
          photoURL={user?.image}
          displayName={user?.name}
          sx={sx}
          {...other}
        />
      )}

      <CustomPopover
        open={popover.open}
        anchorEl={popover.anchorEl}
        onClose={popover.onClose}
        slotProps={{
          paper: { sx: { p: 0, width: 200 } },
          arrow: { offset: 20 },
        }}
      >
        <Box sx={{ p: 2, pb: 1.5 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.name}
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user?.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Box sx={{ p: 1 }}>
          <Button
            fullWidth
            size="medium"
            variant="text"
            // onClose={popover.onClose}
            sx={{ display: 'block', textAlign: 'left', color: 'rgba(142, 51, 255, 1)' }}
            onClick={() => {
              const path = isEmployeeOnly ? '/user/profile' : paths.app.profile.root;
              router.push(path);
              popover.onClose();
            }}
            {...other}
          >
            My Profile
          </Button>

          <SignOutButton
            size="medium"
            variant="text"
            onClose={popover.onClose}
            sx={{ display: 'block', textAlign: 'left' }}
          />
        </Box>
      </CustomPopover>
    </>
  );
}
